import { getCookie, isCountryInMarket } from "../helpers";

$(document).on('ready', function(){
    const country_cookie = getCookie('COUNTRY_SELECTED');
    const selectedCountryInMarket = isCountryInMarket(country_cookie);

    if(country_cookie == 'CA' && selectedCountryInMarket) {
        const $placeholders = $('[data-tax-and-duties-policy]');
        if($placeholders.length > 0) {
            $placeholders.each(function(){
                $(this).html($(this).attr('data-tax-and-duties-policy'));
                $(this).show();
            });
        }
    }
});

